import React, {useEffect, useRef, useState} from "react";
import {Modal} from "antd";
import {useSessionStorage} from "../UIChatStorage";
import Sound from "react-sound";
import play from "../images/play-button.svg";
import pause from "../images/pause-button.svg";
import play1 from "../images/play-button2.svg";
import pause1 from "../images/pause-button2.svg";
import "./UIMessageSound.scss";
import {useTranslation} from "react-i18next";

function UIMessageSound(props: any) {
  const { info } = Modal;
  const [chatFontSize, setChatFontSize]: any = useSessionStorage(
    "chatFontSize",
    ""
  );
  const fileServiceDownloadURL =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
  const soundDetails = props.soundDetails;
  const [isURLError, setURLError]: any = useState(false);
  const [second, setSecond]: any = useState(
    parseInt(soundDetails?.timeRecord?.split(":")[1])
  );
  const [minute, setMinute]: any = useState(
    parseInt(soundDetails?.timeRecord?.split(":")[0])
  );
  //@ts-ignore
  const [playStatus, setPlayStatus]: any = useState(Sound.status.STOPPED);
  const [playing, setPlaying]: any = useState(false);
  const [isLoading, setLoading]: any = useState(false);
  const pauseRef: any = useRef(null);
  const playRef: any = useRef(null);
  const { t } = useTranslation();
  let timer: any;

  const startTimer = async () => {
    timer = setInterval(() => {
      setSecond((prevState: number) => prevState - 1);
    }, 1000);
  };

  useEffect(() => {
    if (playing && minute === 0 && second === 0) {
      setPlaying(false);
    }
    if (playing && second === 0 && minute > 0) {
      setSecond(59);
      setMinute((prevState: number) => prevState - 1);
    }
  }, [second, minute, playing]);

  useEffect(() => {
    if (playing) {
      setSecond((prevState: number) => prevState - 1);
      startTimer();
    }
    return () => {
      clearInterval(timer);
      setSecond(parseInt(soundDetails?.timeRecord?.split(":")[1]));
      setMinute(parseInt(soundDetails?.timeRecord?.split(":")[0]));
    };
  }, [playing]);

  return (
    <div className="box-preview-sound">
      {isLoading && (
        <span style={{ paddingRight: 15, paddingBottom: 5, fill: "#FFF" }}>
          <svg
            className="an-spinning"
            xmlns="http://www.w3.org/2000/svg"
            height="1.5em"
            width="1.5em"
            viewBox="0 0 16 16"
            fill={props.isAnother === 2 ? "#fff" : "#000"}
          >
            <path d="M15 8c0 3.9-3.1 7-7 7s-7-3-7-7H0c0 4 3.6 8 8 8s8-3.6 8-8h-1z" />
          </svg>
        </span>
      )}
      {!isLoading && (
        <img
          id={!playing ? "btn-play" : "btn-pause"}
          ref={!playing ? playRef : pauseRef}
          src={
            props.isAnother === 2
              ? !playing
                ? play
                : pause
              : !playing
              ? play1
              : pause1
          }
          onClick={() => {
            if (pauseRef.current) {
              pauseRef.current.click();
            }
            if (!isURLError && !props.isSelect && !props.isReply) {
              //@ts-ignore
              if (playStatus !== Sound.status.PLAYING) {
                setLoading(true);
                //@ts-ignore
                setPlayStatus(Sound.status.PLAYING);
              } else {
                //@ts-ignore
                setPlayStatus(Sound.status.STOPPED);
              }
            }
          }}
          width="35px"
          height="35px"
          alt="preload"
          style={{
            paddingRight: 15,
            paddingBottom: 5,
            fill: "#FFF",
            cursor: "pointer",
          }}
        />
      )}
      <span
        className={chatFontSize !== "xl" ? "chat-caption" : "chat-meta"}
        style={{ paddingRight: 15, paddingBottom: 5 }}
      >
        {minute < 10 ? "0" + minute : minute}:
        {second < 10 ? "0" + second : second}
      </span>
      {/* <audio controls>
        <source
          src={
            soundDetails?.blobURL || fileServiceDownloadURL + soundDetails?.id
          }
        ></source>
      </audio> */}
      {
        //@ts-ignore
        playStatus === Sound.status.PLAYING && (
          <>
            <Sound
              url={
                soundDetails?.blobURL ||
                fileServiceDownloadURL + soundDetails?.id
              }
              playStatus={playStatus} //(Sound.status.{PLAYING,STOPPED,PAUSED}): The current sound playing status. Change it in successive renders to play, stop, pause and resume the sound.
              volume={100}
              onLoad={() => {
                setLoading(false);
                setPlaying(true);
              }}
              onStop={() => setPlaying(false)}
              onFinishedPlaying={() => {
                //@ts-ignore
                setPlayStatus(Sound.status.STOPPED);
                setPlaying(false);
              }}
              onError={() => {
                info({
                  title: t("Audio file is missing") + ".",
                });
                //@ts-ignore
                setPlayStatus(Sound.status.STOPPED);
                setPlaying(false);
              }}
            />
          
          </>
        )
      }
      <div
        style={{ display: "flex" }}
        className={
          playing
            ? "loader-container" + props.isAnother
            : "loader-container-un" + props.isAnother
        }
      >
        <div className={playing ? "rectangle-1" : "rect-1"}></div>
        <div className={playing ? "rectangle-2" : "rect-2"}></div>
        <div className={playing ? "rectangle-3" : "rect-3"}></div>
        <div className={playing ? "rectangle-4" : "rect-4"}></div>
        <div className={playing ? "rectangle-5" : "rect-5"}></div>
        <div className={playing ? "rectangle-6" : "rect-6"}></div>
        {/* {!playing && (
          <div className={"rect-7"}></div>
        )} */}
        <div className={playing ? "rectangle-5" : "rect-5"}></div>
        <div className={playing ? "rectangle-4" : "rect-4"}></div>
        <div className={playing ? "rectangle-3" : "rect-3"}></div>
        <div className={playing ? "rectangle-2" : "rect-2"}></div>
        <div className={playing ? "rectangle-1" : "rect-1"}></div>
      </div>
    </div>
  );
}

export default React.memo(UIMessageSound);
